import { z } from 'zod'
import { CompanyIdSchema, EntityIdSchema, UserIdSchema, idSchemaV2, isId } from '../ids'
import { AuditPropsSchema } from '../common'
import { AccountListViewPayloadSchema, AreaManagementViewPayloadSchema } from './surface'

export const ViewIdSchema = idSchemaV2('View')
export type ViewId = z.infer<typeof ViewIdSchema>
export const isViewId = isId(ViewIdSchema)

export const ViewNameSchema = z.string().trim().min(1).max(100)

const ViewDetailsSchema = z.object({
  name: ViewNameSchema,
  audienceIds: EntityIdSchema.array(),
})

const ViewRecordSchema = z.object({
  ...AuditPropsSchema.shape,
  ...ViewDetailsSchema.shape,
  viewId: ViewIdSchema,
  companyId: CompanyIdSchema,
  ownerId: UserIdSchema,
})

export const ViewDataSchema = z.discriminatedUnion('surface', [
  z.object({ ...ViewRecordSchema.shape, ...AreaManagementViewPayloadSchema.shape }),
  z.object({ ...ViewRecordSchema.shape, ...AccountListViewPayloadSchema.shape }),
])
export type ViewData = z.infer<typeof ViewDataSchema>

export const UnsavedViewSchema = z.discriminatedUnion('surface', [
  z.object({
    ...ViewDetailsSchema.shape,
    ...AreaManagementViewPayloadSchema.shape,
    audienceIds: EntityIdSchema.array().optional(),
  }),
  z.object({
    ...ViewDetailsSchema.shape,
    ...AccountListViewPayloadSchema.shape,
    audienceIds: EntityIdSchema.array().optional(),
  }),
])
export type UnsavedView = z.infer<typeof UnsavedViewSchema>

// Full replacement of an owned view; audience is required so every update states it explicitly
export const ViewReplacementSchema = z.discriminatedUnion('surface', [
  z.object({ ...ViewDetailsSchema.shape, ...AreaManagementViewPayloadSchema.shape, viewId: ViewIdSchema }),
  z.object({ ...ViewDetailsSchema.shape, ...AccountListViewPayloadSchema.shape, viewId: ViewIdSchema }),
])
export type ViewReplacement = z.infer<typeof ViewReplacementSchema>
